import { fadeIn } from '@/utils/animations';
import { motion } from 'framer-motion';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Footer component that will be reused across pages
const Footer = () => {
  return (
    <motion.footer
      className="bg-green-800 text-white py-12"
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">About PermitTree</h3>
            <p className="text-sm">
              PermitTree is the official online platform of DENR-PENRO (Department of Environment and Natural Resources - Provincial Environment and Natural Resources Office)
              for processing tree-related permits and registrations, committed to the conservation and proper management of the country's natural resources.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:underline">Home</Link></li>
              <li><Link to="/about" className="text-sm hover:underline">About</Link></li>
              <li><Link to="/services" className="text-sm hover:underline">Services</Link></li>
              <li><Link to="/contact" className="text-sm hover:underline">Contact</Link></li>
              <li><Link to="/privacy-policy" className="text-sm hover:underline">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm hover:underline">Terms of Service</Link></li>
              {/* <li><Link to="/credits" className="text-sm hover:underline">Credits</Link></li> */}
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
            <div className="flex space-x-4 mb-4">
              <Link to="#" className="hover:text-green-300">
                <FaFacebook className="h-6 w-6" />
              </Link>
              <Link to="#" className="hover:text-green-300">
                <FaTwitter className="h-6 w-6" />
              </Link>
              <Link to="#" className="hover:text-green-300">
                <FaInstagram className="h-6 w-6" />
              </Link>
            </div>
            <p className="text-sm">
              Email: info@permittree@gmail.com<br />
              Phone: (042) 332 1490
            </p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-green-700 text-center">
          <p className="text-sm">&copy; 2023 PermitTree - DENR-PENRO. All rights reserved.</p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;